import React from 'react';
import { Divider, Placeholder } from 'rsuite';

export const LoadingPlaceholder = () => {
  return (
    <div style={{ margin: '30px 30px 30px' }}>
      <Placeholder.Paragraph graph="square" active />
      <Divider></Divider>
      <Placeholder.Paragraph rows={8} />
      <Divider></Divider>
      <Placeholder.Paragraph graph="image" active />
    </div>
  );
};
